module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-1.55fb95f9.svg";